import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiService from "../services/ApiService";
import { CiSearch } from "react-icons/ci";
import { MdHomeFilled } from "react-icons/md";

const VerifyPhone = () => {
  const [phone, setPhone] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const user_id = searchParams.get('user_id');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!phone.trim()) {
      toast.error("Phone number is required");
      return;
    }
    if (!/^\d{9}$/.test(phone)) {
        toast.error("Phone number is invalid. Enter 9 digits.");
        return;
    }

    setIsLoading(true);

    try {
      const response = await ApiService.request({
        method: "POST",
        url: "/sendOTP",
        data: { 
            user_id: user_id,
            phone: "971" + phone 
        }
      });

      if (response.data.status) {
        toast.success(response.data.message || "OTP sent successfully");
        if(user_id) {
            localStorage.setItem('user_id', user_id);
        }
        navigate("/verify-otp");
      } else {
        toast.error(response.data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("OTP Error:", error);
      toast.error("An error occurred while sending OTP");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="header-banner bg-gradient" id="home">
      <div className="container">
        <div className="row">
          <div
            className="col-md-12 shadow main-heading"
            style={{ display: "flex", flexDirection: "column" }}
          >
            {/* Reused Header */}
            <div className="top-bar d-flex justify-content-between px-4 py-2">
              <div className="top-bar-left">
                <span className="text-secondary">Welcome</span>
                <p className="mb-0 text-base">Verify your phone number</p>
              </div>

              <div className="top-bar-right d-flex align-items-center">
                <Link  to="/">
                        <MdHomeFilled  className="top-bar-search-icon fs-2 mx-2 fw-semibold text-secondary"  />
                </Link>
                <Link to="/search">
                    <CiSearch className="top-bar-search-icon fs-2 text-secondary" />
                </Link>
              </div>
            </div>

            {/* Verify Phone Form */}
            <div className="row">
                <div className="tab col-md-6 col-12 my-5 mx-auto  bg-white rounded border shadow p-4">
                    <h2 className="text-center mb-4">Verify Phone</h2>
                    <p className="text-center text-muted mb-4">
                        Please enter your phone number to receive a verification code.
                    </p>
                    
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="phone" className="form-label required">
                                Phone Number
                            </label>
                            <div className="input-group">
                                <span className="group-prepand bg-light p-2 border ">
                                    +971
                                </span>
                                <input
                                    type="tel"
                                    className="form-control"
                                    id="phone"
                                    placeholder="Phone Number"
                                    maxLength={9}
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
                                    required
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-base w-100 py-2 mb-3"
                            disabled={isLoading}
                        >
                            {isLoading ? "Sending OTP..." : "Send OTP"}
                        </button>

                        <div className="text-center">
                            <Link to="/login" className="text-base">
                                Back to Login
                            </Link>
                        </div>
                    </form>
                </div>

            </div>
            

          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyPhone;
